import { render, staticRenderFns } from "./hot.vue?vue&type=template&id=5e4f4cc2&scoped=true&"
import script from "./hot.vue?vue&type=script&lang=js&"
export * from "./hot.vue?vue&type=script&lang=js&"
import style0 from "./hot.vue?vue&type=style&index=0&id=5e4f4cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f4cc2",
  null
  
)

export default component.exports